export type Colors = {
    [key: string]: string | Record<string, string>;
    defaultFontColor: string;
    primaryBlack: string;
    primaryGreen: string;
    primaryPurple: string;
    primaryPurple2: string;
    primaryPurple3: string;
    primaryWhite: string;
    primaryBlue: string;
    secondaryBlue: string;
    secondaryGreen: string;
    secondaryPurple: string;
    secondaryRed: string;
    extendedGreen1: string;
    extendedGreen2: string;
    extendedGreen3: string;
    extendedGreen4: string;
    extendedGreen5: string;
    extendedYellow: string;
    extendedGrey1: string;
    extendedGrey2: string;
    extendedGrey3: string;
    extendedGrey4: string;
    extendedPurple: string;
    extendedPurple2: string;
    highlight: string;
    extendedPink1: string;
    tagGreen: string;
    tagBackgroundGreen: string;
    tagRed: string;
    tagBackgroundRed: string;
    tagGray: string;
    tagBackgroundGray: string;
    tagPurple: string;
    tagBackgroundPurple: string;
    tagMagenta: string;
    tagBackgroundMagenta: string;
    tagBrown: string;
    tagBackgroundBrown: string;
    navBackground: string;
    iconPrimary: string;
    supportWarning: string;
    borderDisabled: string;
    borderSubtle: string;
    tagBlue: string;
    tagBackgroundBlue: string;
    tagTeal: string;
    tagBackgroundTeal: string;
    marketOverviewBlue: string;
    notificationErrorBackground: string;
};

export const lightColors: Colors = {
    defaultFontColor: "#1A1A1A",
    primaryBlack: "#0D2121",
    primaryGreen: "#113A3F",
    primaryPurple: "#8551DC",
    primaryPurple2: "#6C41B5",
    primaryPurple3: "#502B8C",
    primaryWhite: "#FFFFFF",
    primaryBlue: "#0043CE",
    secondaryBlue: "#D0E2FF",
    secondaryGreen: "#44BAB4",
    secondaryPurple: "#832161",
    secondaryRed: "#D72638",
    extendedGreen1: "#8EC8C5",
    extendedGreen2: "#C1D0CE",
    extendedGreen3: "#DEEDEB",
    extendedGreen4: "#AFDD99",
    extendedGreen5: "#0F9D50",
    extendedYellow: "#FFF9C1",
    extendedGrey1: "#525A5F",
    extendedGrey2: "#F4F8F8",
    extendedGrey3: "#9EA2A5",
    extendedGrey4: "#D9D9D9",
    extendedPurple: "#DDCEF7",
    extendedPurple2: "#B5A2D5",
    highlight: "#FFFA79",
    extendedPink1: "#FFF0F2",
    tagGreen: "#0F9D50",
    tagBackgroundGreen: "#C6FFD5",
    tagRed: "#A2191F",
    tagBackgroundRed: "#FFD7D9",
    tagMagenta: "#9F1853",
    tagBackgroundMagenta: "#FFD6E8",
    tagBrown: "#6B4B00",
    tagBackgroundBrown: "#FFCCAA",
    tagGray: "#161616",
    tagBackgroundGray: "#E0E0E0",
    tagPurple: "#DCC7FF",
    tagBackgroundPurple: "#E8DAFF",
    navBackground: "#0D2121",
    iconPrimary: "#0D2121",
    supportWarning: "#F1C21B",
    borderDisabled: "#C1D0CE",
    borderSubtle: "#C6C6C6",
    tagBlue: "#00539A",
    tagBackgroundBlue: "#D0E2FF",
    tagTeal: "#005D5D",
    tagBackgroundTeal: "#9EF0F0",
    marketOverviewBlue: "#3987B7",
    notificationErrorBackground: "#FFF1F1",
};

export const darkColors: Colors = {
    ...lightColors,
    defaultFontColor: "#FFFFFF",
    primaryPurple: "#C3A4F9",
    primaryBlack: "#FFFFFF",
    primaryWhite: "#252A2C",
    extendedGrey1: "#FFFFFF",
    extendedGrey2: "#343739",
    extendedGreen2: "#8D8D8D",
    extendedGreen3: "#343739",
    secondaryRed: "#FF8389",
    extendedPink1: "#343739",
    extendedGreen5: "#74FA9B",
    navBackground: "#343739",
    iconPrimary: "#FFFFFF",
    borderDisabled: "#3A4043",
    borderSubtle: "#3A4043",
    tagGreen: "#A7F0BA",
    tagBackgroundGreen: "#0E6027",
    notificationErrorBackground: "#383234",
};

export const redGreenColorblindColors: Colors = {
    ...lightColors,
    secondaryRed: "#fcb21e",
    extendedGreen5: "#053d5d",
};
